import Header from '@redirector/front/components/layout/Header';
import { Outlet } from 'react-router-dom';

/**
 * App shell.
 *
 * The <main> deliberately has NO max-width: tables on 1920px+ monitors
 * were getting a horizontal scrollbar even with cells trimmed because
 * the content was capped at 1280px (max-w-7xl) leaving ~640px of empty
 * margin. We let the page fill the viewport instead and rely on the
 * responsive padding (`p-4 sm:p-6 lg:p-8`) to keep gutters comfortable
 * at every size. The Header keeps its own 7xl cap because navigation
 * tabs feel sparse when stretched too wide; the asymmetry is deliberate.
 */
export default function Layout() {
  return (
    <div className="min-h-screen bg-[var(--color-background)] text-[var(--color-text-main)] flex flex-col">
      <Header />
      <main className="flex-1 w-full p-4 sm:p-6 lg:p-8">
        <Outlet />
      </main>
    </div>
  );
}
